import { BrowserRouter, BrowserRouterProps, Redirect, Route, Switch } from 'react-router-dom'
import AppContainer from 'components/features/pfm/App/AppContainer'
import About from 'components/pages/About'
import { PressPage } from 'components/features/pfm/PressPage/PressPage'
import HomePage from 'components/features/pfm/HomePage/HomePage'
import Security from 'components/pages/Security'
import Terms from 'components/pages/Terms'
import Privacy from 'components/pages/Privacy'
import FAQ from 'components/pages/FAQ'
import Logout from 'components/pages/Logout'
import ErrorPageContainer from 'components/features/pfm/ErrorPage/ErrorPageContainer'
import DebtsContainer from 'components/features/pfm/DebtsPage/DebtsContainer'
import { AssetsPage } from 'components/features/pfm/AssetsPage/AssetsPage'
import SpendingContainer from 'components/features/pfm/SpendingPage/SpendingContainer'
import IncomeContainer from 'components/features/pfm/IncomePage/IncomeContainer'
import LoginContainer from 'components/features/pfm/Login/LoginContainer'
import NetworthContainer from 'components/features/pfm/NetworthPage/NetworthContainer'
import CreditContainer from 'components/features/pfm/CreditPage/CreditContainer'
import SettingsPageContainer from 'components/features/pfm/SettingsPage/SettingsPageContainer'
import { CreditLinkagePageContainer } from 'components/features/pfm/CreditLinkagePage/CreditLinkagePageContainer'
import OfferPageContainer from 'components/features/pfm/OfferPage/OfferPageContainer'
import OnboardingRegister from 'components/features/onboarding/OnboardingRegister'
import OnboardingPropertyContainer from 'components/features/pfm/OnboardingProperty/OnboardingPropertyContainer'
import RedemptionPageContainer from 'components/features/pfm/RedemptionPage/RedemptionPageContainer'
import Styleguide from 'components/pages/Styleguide'
import OnboardingSummaryContainer from 'components/features/pfm/OnboardingSummary/OnboardingSummaryContainer'
import SGMeta from 'components/utils/styleguide/SGMeta'
import SGAtoms from 'components/utils/styleguide/SGAtoms'
import SGMolecules from 'components/utils/styleguide/SGMolecules'
import SGOrganisms from 'components/utils/styleguide/SGOrganisms'
import SGLayouts from 'components/utils/styleguide/SGLayouts'
import SGThemes from 'components/utils/styleguide/SGThemes'
import SGWorkspace from 'components/utils/styleguide/SGWorkspace'
import {
  ABOUT_URL,
  ASSETS_URL,
  CREDIT_LINKAGE_URL,
  CREDIT_URL,
  DASHBOARD_URL,
  DEBTS_URL,
  FAQ_URL,
  HOMEPAGE_URL,
  INCOME_URL,
  LOGIN_URL,
  LOGOUT_URL,
  NETWORTH_URL,
  OFFERS_URL,
  ONBOARDING_ENTRY_URL,
  ONBOARDING_PROPERTY_URL,
  ONBOARDING_REGISTER_URL,
  ONBOARDING_SUMMARY_URL,
  OPPORTUNITIES_URL,
  PASSWORD_RESET_URL,
  PRESS_URL,
  PRIVACY_POLICY_URL,
  REWARDS_URL,
  SECURITY_URL,
  SETTINGS_ACCOUNTS_URL,
  SETTINGS_URL,
  SG_ATOMS_URL,
  SG_LAYOUTS_URL,
  SG_META_URL,
  SG_MOLECULES_URL,
  SG_ORGANISMS_URL,
  SG_THEMES_URL,
  SG_WORKSPACE_URL,
  SPENDING_URL,
  STYLEGUIDE_URL,
  TERMS_CONDITIONS_URL,
  REDEMPTION_ENTRY_URL,
  FEED_POSTS_URL,
  FEED_POST_URL,
  FEED_AUTHOR_URL,
  FEED_TAG_URL,
  INTERNAL_ENTRY_URL,
  TRANSACTIONS_URL,
  LINKED_ACCOUNTS_URL,
  EXTERNAL_DASHBOARD_URL,
  FUTURE_URL,
  COACH_URL,
  VIDEO_MEETING_URL,
  COACH_REVIEW_URL,
} from 'tangle-shared'
import { IS_STATUS_APP_IOS } from 'helpers/userAgentHelpers'

import { RewardPage } from 'components/features/rewards/rewardPage/RewardPage/RewardPage'
import { PerformCtaPage } from 'components/features/pfm/PerformCtaPage/PerformCtaPage'
import { OpportunitiesPage } from 'components/features/pfm/OpportunitiesPage/OpportunitiesPage'
import { FeedAuthorPage } from 'components/features/socialFeed/FeedAuthorPage/FeedAuthorPage'
import { FeedPostPage } from 'components/features/socialFeed/FeedPostPage/FeedPostPage'
import { FeedTagPage } from 'components/features/socialFeed/FeedTagPage/FeedTagPage'
import { PasswordReset } from 'components/features/pfm/PasswordReset/PasswordReset'
import { Dashboard2020Page } from 'components/features/pfm/Dashboard2020Page/Dashboard2020Page'
import { TransactionsPage } from 'components/features/pfm/TransactionsPage/TransactionsPage'
import { LinkedAccountsPage } from 'components/features/pfm/LinkedAccountsPage/LinkedAccountsPage'
import { FeedPostsPage } from 'components/features/socialFeed/FeedPostsPage/FeedPostsPage'
import DebugPage from 'components/features/pfm/DebugPage/DebugPage'
import { PublicDashboardPage } from 'components/features/external/PublicDashboardPage/PublicDashboardPage'
import { FuturePage } from 'components/features/future/FuturePage/FuturePage'
import { VideoCallPage } from 'components/features/coaching/advisorVideoCall/VideoCallPage/VideoCallPage'
import { AdvisorReviewPage } from 'components/features/coaching/advisorReviewPage/AdvisorReviewPage/AdvisorReviewPage'
import { AdvisorPublicPage } from 'components/features/coaching/advisorPublicPage/AdvisorPublicPage/AdvisorPublicPage'
import { CoachingPage } from 'components/features/coaching/advisorPage/CoachingPage/CoachingPage'
// import { CreditCardLandingPage } from 'components/features/creditCard/creditCardLanding/CreditCardLandingPage/CreditCardLandingPage'
import { CreditCardPage } from 'components/features/creditCard/creditCardPage/CreditCardPage/CreditCardPage'
import { CreditCardOnboardingPage } from 'components/features/creditCard/creditCardOnboarding/CreditCardOnboardingPage/CreditCardOnboardingPage'
import { GraphQLTestModulePage } from 'graphql/GraphQLTestModulePage'
import { ENV } from 'constants/app'
import { CardTermsPage } from 'components/features/creditCard/creditCardPage/CardTermsPage/CardTermsPage'


declare const __STYLEGUIDE_ENABLED__: boolean

const styleGuideRoutes = (
  <Route path={ STYLEGUIDE_URL }>
    <Styleguide>
      <Route exact path={ SG_LAYOUTS_URL } component={ SGLayouts } />
      <Route exact path={ SG_META_URL } component={ SGMeta } />
      <Route exact path={ SG_ATOMS_URL } component={ SGAtoms } />
      <Route exact path={ SG_MOLECULES_URL } component={ SGMolecules } />
      <Route exact path={ SG_ORGANISMS_URL } component={ SGOrganisms } />
      <Route exact path={ SG_THEMES_URL } component={ SGThemes } />
      <Route exact path={ SG_WORKSPACE_URL } component={ SGWorkspace } />
    </Styleguide>
  </Route>
)

// TODO experiment with delay value on different iOS devices
const BLOCK_NAVIGATION_DELAY = 150

// this function is invoked when navigation gets blocked via <Prompt> component
const getUserConfirmation: BrowserRouterProps['getUserConfirmation'] = IS_STATUS_APP_IOS
  ? (_message, callback) => {
    setTimeout(function () {
      callback(true)
    }, BLOCK_NAVIGATION_DELAY)
  }
  : undefined

const routes = (
  <BrowserRouter getUserConfirmation={ getUserConfirmation }>
    <AppContainer>
      <Switch>
        <Redirect exact from='/resources/' to={ DASHBOARD_URL } />

        <Route exact path={ HOMEPAGE_URL } component={ HomePage } />
        <Route exact path={ FUTURE_URL } component={ FuturePage } />

        <Route exact path={ INTERNAL_ENTRY_URL } component={ () => <Redirect to={ DASHBOARD_URL } /> } />

        { /* Internal Feed pages */ }
        <Route exact path={ FEED_POSTS_URL } component={ FeedPostsPage } />
        <Route exact path={ FEED_AUTHOR_URL } component={ FeedAuthorPage } />
        <Route exact path={ FEED_POST_URL } component={ FeedPostPage } />
        <Route exact path={ FEED_TAG_URL } component={ FeedTagPage } />

        { /* Internal PFM pages */ }
        <Route exact path={ DASHBOARD_URL } component={ Dashboard2020Page } />
        <Route exact path={ TRANSACTIONS_URL } component={ TransactionsPage } />
        <Redirect exact from={ SETTINGS_ACCOUNTS_URL } to={ LINKED_ACCOUNTS_URL } />
        <Route exact path={ LINKED_ACCOUNTS_URL } component={ LinkedAccountsPage } />
        <Route exact path={ SPENDING_URL } component={ SpendingContainer } />
        <Route exact path={ INCOME_URL } component={ IncomeContainer } />
        <Route exact path={ DEBTS_URL } component={ DebtsContainer } />
        <Route exact path={ ASSETS_URL } component={ AssetsPage } />
        <Route exact path={ CREDIT_URL } component={ CreditContainer } />
        <Route exact path={ NETWORTH_URL } component={ NetworthContainer } />
        <Route exact path={ SETTINGS_URL } component={ SettingsPageContainer } />
        <Route exact path={ CREDIT_LINKAGE_URL } component={ CreditLinkagePageContainer } />
        <Route exact path={ `${ OFFERS_URL }/:id` } component={ OfferPageContainer } />
        <Route exact path={ OPPORTUNITIES_URL } component={ OpportunitiesPage } />
        <Route exact path={ REWARDS_URL } component={ RewardPage } />
        <Route exact path={ `${ REDEMPTION_ENTRY_URL }/:step` } component={ RedemptionPageContainer } />
        { /* TODO: move the url to shared */ }
        <Route exact path='/perform-cta' component={ PerformCtaPage } />

        { /* External pages */ }
        <Route exact path={ ABOUT_URL } component={ About } />
        <Route exact path={ PRESS_URL } component={ PressPage } />
        <Route exact path={ SECURITY_URL } component={ Security } />
        <Route exact path={ TERMS_CONDITIONS_URL } component={ Terms } />
        <Route exact path='/credit-card-terms' component={ CardTermsPage } />
        <Route exact path={ PRIVACY_POLICY_URL } component={ Privacy } />
        <Route exact path={ FAQ_URL } component={ FAQ } />
        <Route exact path={ EXTERNAL_DASHBOARD_URL } component={ PublicDashboardPage } />

        { /* Authentication pages */ }
        <Route exact path={ LOGIN_URL } component={ LoginContainer } />
        <Route exact path={ LOGOUT_URL } component={ Logout } />
        <Route exact path={ PASSWORD_RESET_URL } component={ PasswordReset } />

        { /* Onboarding pages */ }
        <Redirect exact from={ ONBOARDING_ENTRY_URL } to={ ONBOARDING_REGISTER_URL } />
        <Route exact path={ ONBOARDING_REGISTER_URL } component={ OnboardingRegister } />
        <Route exact path={ ONBOARDING_PROPERTY_URL } component={ OnboardingPropertyContainer } />
        <Route exact path={ ONBOARDING_SUMMARY_URL } component={ OnboardingSummaryContainer } />
        <Route exact path={ PASSWORD_RESET_URL } component={ PasswordReset } />

        { /* Advisors pages */ }
        <Route exact path={ COACH_URL } component={ CoachingPage } />
        <Route exact path={ VIDEO_MEETING_URL } component={ VideoCallPage } />
        <Route exact path={ COACH_REVIEW_URL } component={ AdvisorReviewPage } />
        <Route exact path={ `${ COACH_URL }/:username` } component={ AdvisorPublicPage } />

        { /* Credit card pages */ }
        {/* <Route exact path={ CREDIT_CARD_URL } component={ CreditCardLandingPage } /> */}
        <Route exact path='/credit-card' component={ CreditCardPage } />
        <Route exact path='/credit-card/onboarding' component={ CreditCardOnboardingPage } />
        <Route exact path='/credit-card/onboarding/:step' component={ CreditCardOnboardingPage } />

        <Route path='/debug' component={ DebugPage } />
        {
          ENV !== 'prod' && (
            <Route path='/graphql' component={ GraphQLTestModulePage } />
          )
        }

        { __STYLEGUIDE_ENABLED__ ? styleGuideRoutes : null }
        <Route path='*' component={ ErrorPageContainer } />
      </Switch>
    </AppContainer>
  </BrowserRouter>
)

export default routes
